// Team FAN — fan pages (smart links, pre-save, bio) + artist link tools.
const en = {
  "fan.poweredBy": "Powered by",
  "fan.language": "Language",
  "fan.loadError": "We couldn't load this page.",
  "fan.retry": "Try again",
  "fan.share": "Share",
  "fan.linkCopied": "Link copied",

  "fan.smart.chooseService": "Choose your music service",
  "fan.smart.play": "Play",
  "fan.smart.playPreview": "Play preview",
  "fan.smart.pausePreview": "Pause preview",
  "fan.smart.noPlatforms": "Streaming links are on their way",
  "fan.smart.noPlatformsDesc": "Check back soon — the artist is adding platforms.",
  "fan.smart.notFound": "Link not found",
  "fan.smart.notFoundDesc": "This smart link doesn't exist or has been removed.",

  "fan.ps.upcoming": "Upcoming release",
  "fan.ps.outNow": "Out now",
  "fan.ps.releasesIn": "Releases in",
  "fan.ps.days": "Days",
  "fan.ps.hours": "Hours",
  "fan.ps.minutes": "Min",
  "fan.ps.seconds": "Sec",
  "fan.ps.presaveSpotify": "Pre-save on Spotify",
  "fan.ps.saveSpotify": "Save on Spotify",
  "fan.ps.redirecting": "Connecting to Spotify…",
  "fan.ps.permission": "We only add this release to your library and follow the artist. Nothing else.",
  "fan.ps.successTitle": "You're all set!",
  "fan.ps.successDesc": "It will appear in your Spotify library on release day.",
  "fan.ps.successReleased": "Saved to your Spotify library. Enjoy!",
  "fan.ps.notifyTitle": "Get notified on release day",
  "fan.ps.emailPlaceholder": "Your email address",
  "fan.ps.notifyMe": "Notify me",
  "fan.ps.notifySuccess": "Done! We'll email you when it's out.",
  "fan.ps.notifyAlready": "You're already on the list.",
  "fan.ps.emailInvalid": "Please enter a valid email address.",
  "fan.ps.consent": "Your email is only used to tell you about this release.",
  "fan.ps.fans": "{count} fans pre-saved",
  "fan.ps.fanOne": "1 fan pre-saved",
  "fan.ps.spotifyUnavailable": "Spotify pre-save is temporarily unavailable. Leave your email and we'll let you know when it's out.",
  "fan.ps.errorDenied": "Spotify access was cancelled. You can try again anytime.",
  "fan.ps.errorGeneric": "Something went wrong with Spotify. Please try again.",
  "fan.ps.appleMusic": "Open in Apple Music",
  "fan.ps.or": "or",
  "fan.ps.notFound": "Campaign not found",
  "fan.ps.notFoundDesc": "This pre-save link may have expired or been removed.",

  "fan.bio.latest": "Latest releases",
  "fan.bio.links": "Links",
  "fan.bio.music": "Music",
  "fan.bio.listen": "Listen",
  "fan.bio.notFound": "Artist not found",
  "fan.bio.notFoundDesc": "This page doesn't exist or the artist changed their link.",
  "fan.bio.empty": "Nothing here yet — check back soon.",

  "fan.cardPreview.button": "Preview social card",
  "fan.cardPreview.title": "Social card preview",
  "fan.cardPreview.desc": "This is how your link appears on WhatsApp, Instagram, X, Discord and more.",
  "fan.cardPreview.copyShare": "Copy share link",
  "fan.cardPreview.copyDirect": "Copy direct link",
  "fan.cardPreview.open": "Open page",
  "fan.cardPreview.download": "Download image",
  "fan.cardPreview.hint": "Always share the share link — it shows this preview card, then sends fans to your page.",
  "fan.cardPreview.error": "Couldn't generate the preview card.",
  "fan.cardPreview.shareLink": "Share link",
  "fan.cardPreview.directLink": "Direct link",

  "fan.confirm.cancel": "Cancel",
  "fan.confirm.delete": "Delete",

  "fan.qr.title": "QR code",
  "fan.qr.desc": "Print it on posters, merch or flyers. Scans are tracked in QR Codes.",
  "fan.qr.download": "Download PNG",
  "fan.qr.generating": "Generating QR code…",
  "fan.qr.error": "Couldn't create the QR code.",

  "fan.sl.title": "Smart Links",
  "fan.sl.subtitle": "One link for every platform — with a rich social preview.",
  "fan.sl.create": "New smart link",
  "fan.sl.createTitle": "New smart link",
  "fan.sl.editTitle": "Edit smart link",
  "fan.sl.edit": "Edit",
  "fan.sl.basics": "Basics",
  "fan.sl.titleLabel": "Title",
  "fan.sl.titlePh": "e.g. Midnight Drive",
  "fan.sl.artistLabel": "Artist name",
  "fan.sl.artistPh": "Shown under the title",
  "fan.sl.slugLabel": "Custom URL",
  "fan.sl.slugPh": "midnight-drive",
  "fan.sl.slugAvailable": "Available",
  "fan.sl.slugTaken": "Already taken",
  "fan.sl.slugInvalid": "Use lowercase letters, numbers and dashes",
  "fan.sl.cover": "Cover art",
  "fan.sl.uploadCover": "Click to upload a cover",
  "fan.sl.background": "Background image (optional)",
  "fan.sl.uploadBg": "Upload background",
  "fan.sl.previewUrl": "30-second preview URL (optional)",
  "fan.sl.previewHint": "Direct MP3/AAC link. Filled automatically when Spotify provides one.",
  "fan.sl.platforms": "Platform links",
  "fan.sl.autofill": "Find links automatically",
  "fan.sl.autofillHint": "Paste any Spotify, Apple Music or YouTube link — or leave empty to search by title and artist.",
  "fan.sl.autofillPh": "https://open.spotify.com/track/…",
  "fan.sl.autofillSearching": "Searching platforms…",
  "fan.sl.autofillFound": "Found {count} platform links",
  "fan.sl.autofillNone": "No links found for this release yet",
  "fan.sl.save": "Save",
  "fan.sl.saving": "Saving…",
  "fan.sl.created": "Smart link created",
  "fan.sl.updated": "Smart link updated",
  "fan.sl.deleted": "Smart link deleted",
  "fan.sl.errorSave": "Couldn't save the smart link",
  "fan.sl.errorDelete": "Couldn't delete the smart link",
  "fan.sl.errorFetch": "Couldn't load your smart links",
  "fan.sl.errorUpload": "Image upload failed",
  "fan.sl.required": "Title and custom URL are required",
  "fan.sl.empty": "No smart links yet",
  "fan.sl.emptyDesc": "Create one link that sends fans to your music on every platform.",
  "fan.sl.visits": "Visits",
  "fan.sl.clicks": "Clicks",
  "fan.sl.ctr": "CTR",
  "fan.sl.analytics": "Analytics",
  "fan.sl.byPlatform": "By platform",
  "fan.sl.byCountry": "By country",
  "fan.sl.byReferrer": "Top sources",
  "fan.sl.last30": "Last 30 days",
  "fan.sl.noData": "No clicks yet. Share your link to start collecting data.",
  "fan.sl.countryNote": "Country comes from the network or the visitor's browser language.",
  "fan.sl.unknown": "Unknown",
  "fan.sl.direct": "Direct / apps",
  "fan.sl.deleteTitle": "Delete this smart link?",
  "fan.sl.deleteDesc": "The link will stop working for everyone who has it. This can't be undone.",
  "fan.sl.qr": "QR code",
  "fan.sl.copyShare": "Copy share link",
  "fan.sl.platformsCount": "{count} platforms",
  "fan.sl.cancel": "Cancel",

  "fan.psm.title": "Pre-Save Campaigns",
  "fan.psm.subtitle": "Real Spotify pre-saves and release-day emails for your upcoming music.",
  "fan.psm.create": "New campaign",
  "fan.psm.newTitle": "New pre-save campaign",
  "fan.psm.release": "Release",
  "fan.psm.chooseRelease": "Choose a release…",
  "fan.psm.releaseDate": "Release date",
  "fan.psm.spotifyUri": "Spotify album or track link",
  "fan.psm.spotifyUriHint": "Optional before release — we also find it automatically by UPC/ISRC on release day.",
  "fan.psm.upc": "UPC (optional)",
  "fan.psm.spotifyArtist": "Spotify artist link (fans auto-follow)",
  "fan.psm.appleId": "Apple Music album ID (optional)",
  "fan.psm.description": "Message to fans",
  "fan.psm.descPh": "Tell fans why they should pre-save…",
  "fan.psm.background": "Background image",
  "fan.psm.uploadBg": "Upload background",
  "fan.psm.bgHint": "Recommended: 1920×1080 landscape image",
  "fan.psm.createBtn": "Create campaign",
  "fan.psm.creating": "Creating…",
  "fan.psm.created": "Campaign created",
  "fan.psm.createError": "Couldn't create the campaign",
  "fan.psm.deleted": "Campaign deleted",
  "fan.psm.deleteError": "Couldn't delete the campaign",
  "fan.psm.fetchError": "Couldn't load campaigns",
  "fan.psm.required": "Choose a release and a release date",
  "fan.psm.empty": "No campaigns yet",
  "fan.psm.emptyDesc": "Build momentum before release day with a real Spotify pre-save.",
  "fan.psm.createFirst": "Create your first campaign",
  "fan.psm.active": "Live",
  "fan.psm.released": "Released",
  "fan.psm.daysLeft": "days left",
  "fan.psm.saves": "Spotify pre-saves",
  "fan.psm.emails": "Emails",
  "fan.psm.howItWorks": "Fans connect Spotify once; on release day the music is saved to their library automatically.",
  "fan.psm.deleteTitle": "Delete this campaign?",
  "fan.psm.deleteDesc": "The pre-save page will stop working. Existing pre-saves won't be processed.",
  "fan.psm.exportEmails": "Export emails",
  "fan.psm.noEmails": "No emails collected yet",
  "fan.psm.cancel": "Cancel",
  "fan.psm.editTitle": "Edit campaign",
  "fan.psm.updated": "Campaign updated",

  "fan.bl.urlTitle": "Your public URL",
  "fan.bl.urlDesc": "Claim a short, memorable link for your bio page.",
  "fan.bl.slugPh": "yourname",
  "fan.bl.checking": "Checking…",
  "fan.bl.available": "Available",
  "fan.bl.taken": "Already taken",
  "fan.bl.invalid": "3–30 characters: a–z, 0–9, dot, dash, underscore",
  "fan.bl.reserved": "This name is reserved",
  "fan.bl.yours": "This is your current URL",
  "fan.bl.claim": "Claim",
  "fan.bl.claimed": "Your URL is live!",
  "fan.bl.claimError": "Couldn't claim this URL",
  "fan.bl.noSlug": "Claim a URL to get a link that's easy to share.",
  "fan.bl.openPage": "Open page",
  "fan.bl.namePh": "Your artist name",
  "fan.bl.bioPh": "Tell fans who you are…",
  "fan.bl.uploadPhoto": "Upload photo",
  "fan.bl.emptyLinks": "No links yet",
  "fan.bl.emptyLinksDesc": "Add your merch store, tour dates, newsletter or anything else.",
  "fan.bl.emptyPreview": "Your links will appear here",

  "fan.qrg.brand": "Brand",
  "fan.qrg.classic": "Classic",
  "fan.qrg.inverted": "Inverted",
  "fan.qrg.gold": "Gold",
  "fan.qrg.presets": "Color presets",
  "fan.qrg.small": "Small (256 px)",
  "fan.qrg.medium": "Medium (512 px)",
  "fan.qrg.large": "Large (1024 px)",
  "fan.qrg.lowContrast": "Low contrast — some phones may not scan this code.",
  "fan.qrg.deleteTitle": "Delete this QR code?",
  "fan.qrg.deleteDesc": "Printed copies will stop being tracked.",
  "fan.qrg.tracked": "Scans are tracked automatically",
  "fan.qrg.copyUrl": "Copy target URL",
};

const tr = {
  "fan.poweredBy": "Altyapı",
  "fan.language": "Dil",
  "fan.loadError": "Bu sayfa yüklenemedi.",
  "fan.retry": "Tekrar dene",
  "fan.share": "Paylaş",
  "fan.linkCopied": "Bağlantı kopyalandı",

  "fan.smart.chooseService": "Müzik servisini seç",
  "fan.smart.play": "Dinle",
  "fan.smart.playPreview": "Önizlemeyi çal",
  "fan.smart.pausePreview": "Önizlemeyi durdur",
  "fan.smart.noPlatforms": "Dinleme bağlantıları yolda",
  "fan.smart.noPlatformsDesc": "Yakında tekrar bak — sanatçı platformları ekliyor.",
  "fan.smart.notFound": "Bağlantı bulunamadı",
  "fan.smart.notFoundDesc": "Bu akıllı link mevcut değil ya da kaldırılmış.",

  "fan.ps.upcoming": "Yakında çıkıyor",
  "fan.ps.outNow": "Şimdi yayında",
  "fan.ps.releasesIn": "Çıkışa kalan",
  "fan.ps.days": "Gün",
  "fan.ps.hours": "Saat",
  "fan.ps.minutes": "Dk",
  "fan.ps.seconds": "Sn",
  "fan.ps.presaveSpotify": "Spotify'da ön kaydet",
  "fan.ps.saveSpotify": "Spotify'a kaydet",
  "fan.ps.redirecting": "Spotify'a bağlanılıyor…",
  "fan.ps.permission": "Sadece bu yayını kütüphanene ekler ve sanatçıyı takip ederiz. Başka hiçbir şey yapmayız.",
  "fan.ps.successTitle": "Her şey hazır!",
  "fan.ps.successDesc": "Çıkış günü Spotify kütüphanende olacak.",
  "fan.ps.successReleased": "Spotify kütüphanene kaydedildi. Keyfini çıkar!",
  "fan.ps.notifyTitle": "Çıkış günü haber al",
  "fan.ps.emailPlaceholder": "E-posta adresin",
  "fan.ps.notifyMe": "Bana haber ver",
  "fan.ps.notifySuccess": "Tamam! Yayınlandığında e-posta göndereceğiz.",
  "fan.ps.notifyAlready": "Zaten listedesin.",
  "fan.ps.emailInvalid": "Lütfen geçerli bir e-posta adresi gir.",
  "fan.ps.consent": "E-postan yalnızca bu yayın hakkında bilgi vermek için kullanılır.",
  "fan.ps.fans": "{count} hayran ön kayıt yaptı",
  "fan.ps.fanOne": "1 hayran ön kayıt yaptı",
  "fan.ps.spotifyUnavailable": "Spotify ön kaydı şu anda kullanılamıyor. E-postanı bırak, çıktığında haber verelim.",
  "fan.ps.errorDenied": "Spotify erişimi iptal edildi. İstediğin zaman tekrar deneyebilirsin.",
  "fan.ps.errorGeneric": "Spotify ile bir sorun oluştu. Lütfen tekrar dene.",
  "fan.ps.appleMusic": "Apple Music'te aç",
  "fan.ps.or": "veya",
  "fan.ps.notFound": "Kampanya bulunamadı",
  "fan.ps.notFoundDesc": "Bu ön kayıt bağlantısının süresi dolmuş ya da kaldırılmış olabilir.",

  "fan.bio.latest": "Son yayınlar",
  "fan.bio.links": "Bağlantılar",
  "fan.bio.music": "Müzik",
  "fan.bio.listen": "Dinle",
  "fan.bio.notFound": "Sanatçı bulunamadı",
  "fan.bio.notFoundDesc": "Bu sayfa mevcut değil ya da sanatçı bağlantısını değiştirmiş.",
  "fan.bio.empty": "Henüz burada bir şey yok — yakında tekrar bak.",

  "fan.cardPreview.button": "Sosyal kartı önizle",
  "fan.cardPreview.title": "Sosyal kart önizlemesi",
  "fan.cardPreview.desc": "Bağlantın WhatsApp, Instagram, X, Discord ve diğerlerinde böyle görünür.",
  "fan.cardPreview.copyShare": "Paylaşım linkini kopyala",
  "fan.cardPreview.copyDirect": "Doğrudan linki kopyala",
  "fan.cardPreview.open": "Sayfayı aç",
  "fan.cardPreview.download": "Görseli indir",
  "fan.cardPreview.hint": "Her zaman paylaşım linkini kullan — önce bu kartı gösterir, sonra hayranları sayfana yönlendirir.",
  "fan.cardPreview.error": "Önizleme kartı oluşturulamadı.",
  "fan.cardPreview.shareLink": "Paylaşım linki",
  "fan.cardPreview.directLink": "Doğrudan link",

  "fan.confirm.cancel": "Vazgeç",
  "fan.confirm.delete": "Sil",

  "fan.qr.title": "QR kod",
  "fan.qr.desc": "Afiş, merch veya broşürlere bas. Taramalar QR Kodlar sayfasında takip edilir.",
  "fan.qr.download": "PNG indir",
  "fan.qr.generating": "QR kod oluşturuluyor…",
  "fan.qr.error": "QR kod oluşturulamadı.",

  "fan.sl.title": "Akıllı Linkler",
  "fan.sl.subtitle": "Tüm platformlar için tek link — zengin sosyal önizleme ile.",
  "fan.sl.create": "Yeni akıllı link",
  "fan.sl.createTitle": "Yeni akıllı link",
  "fan.sl.editTitle": "Akıllı linki düzenle",
  "fan.sl.edit": "Düzenle",
  "fan.sl.basics": "Temel bilgiler",
  "fan.sl.titleLabel": "Başlık",
  "fan.sl.titlePh": "örn. Gece Yolculuğu",
  "fan.sl.artistLabel": "Sanatçı adı",
  "fan.sl.artistPh": "Başlığın altında gösterilir",
  "fan.sl.slugLabel": "Özel URL",
  "fan.sl.slugPh": "gece-yolculugu",
  "fan.sl.slugAvailable": "Kullanılabilir",
  "fan.sl.slugTaken": "Zaten alınmış",
  "fan.sl.slugInvalid": "Küçük harf, rakam ve tire kullan",
  "fan.sl.cover": "Kapak görseli",
  "fan.sl.uploadCover": "Kapak yüklemek için tıkla",
  "fan.sl.background": "Arka plan görseli (isteğe bağlı)",
  "fan.sl.uploadBg": "Arka plan yükle",
  "fan.sl.previewUrl": "30 saniyelik önizleme URL'si (isteğe bağlı)",
  "fan.sl.previewHint": "Doğrudan MP3/AAC linki. Spotify sağlıyorsa otomatik doldurulur.",
  "fan.sl.platforms": "Platform linkleri",
  "fan.sl.autofill": "Linkleri otomatik bul",
  "fan.sl.autofillHint": "Herhangi bir Spotify, Apple Music veya YouTube linki yapıştır — ya da boş bırakıp başlık ve sanatçıyla ara.",
  "fan.sl.autofillPh": "https://open.spotify.com/track/…",
  "fan.sl.autofillSearching": "Platformlar aranıyor…",
  "fan.sl.autofillFound": "{count} platform linki bulundu",
  "fan.sl.autofillNone": "Bu yayın için henüz link bulunamadı",
  "fan.sl.save": "Kaydet",
  "fan.sl.saving": "Kaydediliyor…",
  "fan.sl.created": "Akıllı link oluşturuldu",
  "fan.sl.updated": "Akıllı link güncellendi",
  "fan.sl.deleted": "Akıllı link silindi",
  "fan.sl.errorSave": "Akıllı link kaydedilemedi",
  "fan.sl.errorDelete": "Akıllı link silinemedi",
  "fan.sl.errorFetch": "Akıllı linkler yüklenemedi",
  "fan.sl.errorUpload": "Görsel yüklenemedi",
  "fan.sl.required": "Başlık ve özel URL zorunludur",
  "fan.sl.empty": "Henüz akıllı link yok",
  "fan.sl.emptyDesc": "Hayranlarını her platformdaki müziğine yönlendiren tek bir link oluştur.",
  "fan.sl.visits": "Ziyaret",
  "fan.sl.clicks": "Tıklama",
  "fan.sl.ctr": "TO",
  "fan.sl.analytics": "Analiz",
  "fan.sl.byPlatform": "Platforma göre",
  "fan.sl.byCountry": "Ülkeye göre",
  "fan.sl.byReferrer": "En çok gelen kaynaklar",
  "fan.sl.last30": "Son 30 gün",
  "fan.sl.noData": "Henüz tıklama yok. Veri toplamak için linkini paylaş.",
  "fan.sl.countryNote": "Ülke bilgisi ağdan veya ziyaretçinin tarayıcı dilinden alınır.",
  "fan.sl.unknown": "Bilinmiyor",
  "fan.sl.direct": "Doğrudan / uygulamalar",
  "fan.sl.deleteTitle": "Bu akıllı link silinsin mi?",
  "fan.sl.deleteDesc": "Link, sahip olan herkes için çalışmayı durduracak. Bu işlem geri alınamaz.",
  "fan.sl.qr": "QR kod",
  "fan.sl.copyShare": "Paylaşım linkini kopyala",
  "fan.sl.platformsCount": "{count} platform",
  "fan.sl.cancel": "Vazgeç",

  "fan.psm.title": "Ön Kayıt Kampanyaları",
  "fan.psm.subtitle": "Yaklaşan müziğin için gerçek Spotify ön kayıtları ve çıkış günü e-postaları.",
  "fan.psm.create": "Yeni kampanya",
  "fan.psm.newTitle": "Yeni ön kayıt kampanyası",
  "fan.psm.release": "Yayın",
  "fan.psm.chooseRelease": "Bir yayın seç…",
  "fan.psm.releaseDate": "Çıkış tarihi",
  "fan.psm.spotifyUri": "Spotify albüm veya şarkı linki",
  "fan.psm.spotifyUriHint": "Çıkıştan önce isteğe bağlı — çıkış günü UPC/ISRC ile otomatik de buluruz.",
  "fan.psm.upc": "UPC (isteğe bağlı)",
  "fan.psm.spotifyArtist": "Spotify sanatçı linki (hayranlar otomatik takip eder)",
  "fan.psm.appleId": "Apple Music albüm kimliği (isteğe bağlı)",
  "fan.psm.description": "Hayranlara mesaj",
  "fan.psm.descPh": "Hayranlarına neden ön kayıt yapmaları gerektiğini anlat…",
  "fan.psm.background": "Arka plan görseli",
  "fan.psm.uploadBg": "Arka plan yükle",
  "fan.psm.bgHint": "Önerilen: 1920×1080 yatay görsel",
  "fan.psm.createBtn": "Kampanya oluştur",
  "fan.psm.creating": "Oluşturuluyor…",
  "fan.psm.created": "Kampanya oluşturuldu",
  "fan.psm.createError": "Kampanya oluşturulamadı",
  "fan.psm.deleted": "Kampanya silindi",
  "fan.psm.deleteError": "Kampanya silinemedi",
  "fan.psm.fetchError": "Kampanyalar yüklenemedi",
  "fan.psm.required": "Bir yayın ve çıkış tarihi seç",
  "fan.psm.empty": "Henüz kampanya yok",
  "fan.psm.emptyDesc": "Gerçek bir Spotify ön kaydıyla çıkış gününden önce ivme kazan.",
  "fan.psm.createFirst": "İlk kampanyanı oluştur",
  "fan.psm.active": "Aktif",
  "fan.psm.released": "Yayınlandı",
  "fan.psm.daysLeft": "gün kaldı",
  "fan.psm.saves": "Spotify ön kaydı",
  "fan.psm.emails": "E-posta",
  "fan.psm.howItWorks": "Hayranlar Spotify'ı bir kez bağlar; çıkış günü müzik otomatik olarak kütüphanelerine kaydedilir.",
  "fan.psm.deleteTitle": "Bu kampanya silinsin mi?",
  "fan.psm.deleteDesc": "Ön kayıt sayfası çalışmayı durduracak. Mevcut ön kayıtlar işlenmeyecek.",
  "fan.psm.exportEmails": "E-postaları dışa aktar",
  "fan.psm.noEmails": "Henüz e-posta toplanmadı",
  "fan.psm.cancel": "Vazgeç",
  "fan.psm.editTitle": "Kampanyayı düzenle",
  "fan.psm.updated": "Kampanya güncellendi",

  "fan.bl.urlTitle": "Herkese açık URL'in",
  "fan.bl.urlDesc": "Bio sayfan için kısa ve akılda kalıcı bir link al.",
  "fan.bl.slugPh": "adin",
  "fan.bl.checking": "Kontrol ediliyor…",
  "fan.bl.available": "Kullanılabilir",
  "fan.bl.taken": "Zaten alınmış",
  "fan.bl.invalid": "3–30 karakter: a–z, 0–9, nokta, tire, alt çizgi",
  "fan.bl.reserved": "Bu ad ayrılmış",
  "fan.bl.yours": "Bu senin mevcut URL'in",
  "fan.bl.claim": "Al",
  "fan.bl.claimed": "URL'in yayında!",
  "fan.bl.claimError": "Bu URL alınamadı",
  "fan.bl.noSlug": "Kolay paylaşılan bir link için bir URL al.",
  "fan.bl.openPage": "Sayfayı aç",
  "fan.bl.namePh": "Sanatçı adın",
  "fan.bl.bioPh": "Hayranlarına kendini anlat…",
  "fan.bl.uploadPhoto": "Fotoğraf yükle",
  "fan.bl.emptyLinks": "Henüz link yok",
  "fan.bl.emptyLinksDesc": "Merch mağazanı, konser tarihlerini, bültenini veya başka bir şeyi ekle.",
  "fan.bl.emptyPreview": "Linklerin burada görünecek",

  "fan.qrg.brand": "Marka",
  "fan.qrg.classic": "Klasik",
  "fan.qrg.inverted": "Ters",
  "fan.qrg.gold": "Altın",
  "fan.qrg.presets": "Renk hazır ayarları",
  "fan.qrg.small": "Küçük (256 px)",
  "fan.qrg.medium": "Orta (512 px)",
  "fan.qrg.large": "Büyük (1024 px)",
  "fan.qrg.lowContrast": "Düşük kontrast — bazı telefonlar bu kodu okuyamayabilir.",
  "fan.qrg.deleteTitle": "Bu QR kod silinsin mi?",
  "fan.qrg.deleteDesc": "Basılı kopyaların taramaları artık takip edilmeyecek.",
  "fan.qrg.tracked": "Taramalar otomatik takip edilir",
  "fan.qrg.copyUrl": "Hedef URL'yi kopyala",
};

const es = {
  "fan.poweredBy": "Con la tecnología de",
  "fan.language": "Idioma",
  "fan.loadError": "No pudimos cargar esta página.",
  "fan.retry": "Reintentar",
  "fan.share": "Compartir",
  "fan.linkCopied": "Enlace copiado",

  "fan.smart.chooseService": "Elige tu servicio de música",
  "fan.smart.play": "Escuchar",
  "fan.smart.playPreview": "Reproducir avance",
  "fan.smart.pausePreview": "Pausar avance",
  "fan.smart.noPlatforms": "Los enlaces están en camino",
  "fan.smart.noPlatformsDesc": "Vuelve pronto: el artista está añadiendo plataformas.",
  "fan.smart.notFound": "Enlace no encontrado",
  "fan.smart.notFoundDesc": "Este smart link no existe o fue eliminado.",

  "fan.ps.upcoming": "Próximo lanzamiento",
  "fan.ps.outNow": "Ya disponible",
  "fan.ps.releasesIn": "Sale en",
  "fan.ps.days": "Días",
  "fan.ps.hours": "Horas",
  "fan.ps.minutes": "Min",
  "fan.ps.seconds": "Seg",
  "fan.ps.presaveSpotify": "Pre-guardar en Spotify",
  "fan.ps.saveSpotify": "Guardar en Spotify",
  "fan.ps.redirecting": "Conectando con Spotify…",
  "fan.ps.permission": "Solo añadimos este lanzamiento a tu biblioteca y seguimos al artista. Nada más.",
  "fan.ps.successTitle": "¡Listo!",
  "fan.ps.successDesc": "Aparecerá en tu biblioteca de Spotify el día del lanzamiento.",
  "fan.ps.successReleased": "Guardado en tu biblioteca de Spotify. ¡Disfrútalo!",
  "fan.ps.notifyTitle": "Avísame el día del lanzamiento",
  "fan.ps.emailPlaceholder": "Tu correo electrónico",
  "fan.ps.notifyMe": "Avísame",
  "fan.ps.notifySuccess": "¡Hecho! Te escribiremos cuando salga.",
  "fan.ps.notifyAlready": "Ya estás en la lista.",
  "fan.ps.emailInvalid": "Introduce un correo electrónico válido.",
  "fan.ps.consent": "Tu correo solo se usa para avisarte de este lanzamiento.",
  "fan.ps.fans": "{count} fans lo pre-guardaron",
  "fan.ps.fanOne": "1 fan lo pre-guardó",
  "fan.ps.spotifyUnavailable": "El pre-guardado en Spotify no está disponible ahora. Deja tu correo y te avisaremos cuando salga.",
  "fan.ps.errorDenied": "Se canceló el acceso a Spotify. Puedes intentarlo de nuevo cuando quieras.",
  "fan.ps.errorGeneric": "Algo salió mal con Spotify. Inténtalo de nuevo.",
  "fan.ps.appleMusic": "Abrir en Apple Music",
  "fan.ps.or": "o",
  "fan.ps.notFound": "Campaña no encontrada",
  "fan.ps.notFoundDesc": "Este enlace de pre-guardado puede haber caducado o sido eliminado.",

  "fan.bio.latest": "Últimos lanzamientos",
  "fan.bio.links": "Enlaces",
  "fan.bio.music": "Música",
  "fan.bio.listen": "Escuchar",
  "fan.bio.notFound": "Artista no encontrado",
  "fan.bio.notFoundDesc": "Esta página no existe o el artista cambió su enlace.",
  "fan.bio.empty": "Aún no hay nada aquí — vuelve pronto.",

  "fan.cardPreview.button": "Vista previa de la tarjeta",
  "fan.cardPreview.title": "Vista previa de la tarjeta social",
  "fan.cardPreview.desc": "Así se ve tu enlace en WhatsApp, Instagram, X, Discord y más.",
  "fan.cardPreview.copyShare": "Copiar enlace para compartir",
  "fan.cardPreview.copyDirect": "Copiar enlace directo",
  "fan.cardPreview.open": "Abrir página",
  "fan.cardPreview.download": "Descargar imagen",
  "fan.cardPreview.hint": "Comparte siempre el enlace para compartir: muestra esta tarjeta y luego lleva a los fans a tu página.",
  "fan.cardPreview.error": "No se pudo generar la tarjeta.",
  "fan.cardPreview.shareLink": "Enlace para compartir",
  "fan.cardPreview.directLink": "Enlace directo",

  "fan.confirm.cancel": "Cancelar",
  "fan.confirm.delete": "Eliminar",

  "fan.qr.title": "Código QR",
  "fan.qr.desc": "Imprímelo en carteles, merch o flyers. Los escaneos se registran en Códigos QR.",
  "fan.qr.download": "Descargar PNG",
  "fan.qr.generating": "Generando código QR…",
  "fan.qr.error": "No se pudo crear el código QR.",

  "fan.sl.title": "Smart Links",
  "fan.sl.subtitle": "Un enlace para todas las plataformas, con vista previa social.",
  "fan.sl.create": "Nuevo smart link",
  "fan.sl.createTitle": "Nuevo smart link",
  "fan.sl.editTitle": "Editar smart link",
  "fan.sl.edit": "Editar",
  "fan.sl.basics": "Información básica",
  "fan.sl.titleLabel": "Título",
  "fan.sl.titlePh": "p. ej. Midnight Drive",
  "fan.sl.artistLabel": "Nombre del artista",
  "fan.sl.artistPh": "Se muestra bajo el título",
  "fan.sl.slugLabel": "URL personalizada",
  "fan.sl.slugPh": "midnight-drive",
  "fan.sl.slugAvailable": "Disponible",
  "fan.sl.slugTaken": "Ya está en uso",
  "fan.sl.slugInvalid": "Usa minúsculas, números y guiones",
  "fan.sl.cover": "Portada",
  "fan.sl.uploadCover": "Haz clic para subir una portada",
  "fan.sl.background": "Imagen de fondo (opcional)",
  "fan.sl.uploadBg": "Subir fondo",
  "fan.sl.previewUrl": "URL de avance de 30 segundos (opcional)",
  "fan.sl.previewHint": "Enlace directo MP3/AAC. Se rellena solo si Spotify ofrece uno.",
  "fan.sl.platforms": "Enlaces de plataformas",
  "fan.sl.autofill": "Buscar enlaces automáticamente",
  "fan.sl.autofillHint": "Pega un enlace de Spotify, Apple Music o YouTube, o déjalo vacío para buscar por título y artista.",
  "fan.sl.autofillPh": "https://open.spotify.com/track/…",
  "fan.sl.autofillSearching": "Buscando plataformas…",
  "fan.sl.autofillFound": "Se encontraron {count} enlaces",
  "fan.sl.autofillNone": "Aún no hay enlaces para este lanzamiento",
  "fan.sl.save": "Guardar",
  "fan.sl.saving": "Guardando…",
  "fan.sl.created": "Smart link creado",
  "fan.sl.updated": "Smart link actualizado",
  "fan.sl.deleted": "Smart link eliminado",
  "fan.sl.errorSave": "No se pudo guardar el smart link",
  "fan.sl.errorDelete": "No se pudo eliminar el smart link",
  "fan.sl.errorFetch": "No se pudieron cargar tus smart links",
  "fan.sl.errorUpload": "Error al subir la imagen",
  "fan.sl.required": "El título y la URL personalizada son obligatorios",
  "fan.sl.empty": "Aún no hay smart links",
  "fan.sl.emptyDesc": "Crea un enlace que lleve a tus fans a tu música en todas las plataformas.",
  "fan.sl.visits": "Visitas",
  "fan.sl.clicks": "Clics",
  "fan.sl.ctr": "CTR",
  "fan.sl.analytics": "Analítica",
  "fan.sl.byPlatform": "Por plataforma",
  "fan.sl.byCountry": "Por país",
  "fan.sl.byReferrer": "Principales fuentes",
  "fan.sl.last30": "Últimos 30 días",
  "fan.sl.noData": "Aún no hay clics. Comparte tu enlace para empezar a recopilar datos.",
  "fan.sl.countryNote": "El país proviene de la red o del idioma del navegador del visitante.",
  "fan.sl.unknown": "Desconocido",
  "fan.sl.direct": "Directo / apps",
  "fan.sl.deleteTitle": "¿Eliminar este smart link?",
  "fan.sl.deleteDesc": "El enlace dejará de funcionar para todos. No se puede deshacer.",
  "fan.sl.qr": "Código QR",
  "fan.sl.copyShare": "Copiar enlace para compartir",
  "fan.sl.platformsCount": "{count} plataformas",
  "fan.sl.cancel": "Cancelar",

  "fan.psm.title": "Campañas de pre-guardado",
  "fan.psm.subtitle": "Pre-guardados reales en Spotify y correos el día del lanzamiento.",
  "fan.psm.create": "Nueva campaña",
  "fan.psm.newTitle": "Nueva campaña de pre-guardado",
  "fan.psm.release": "Lanzamiento",
  "fan.psm.chooseRelease": "Elige un lanzamiento…",
  "fan.psm.releaseDate": "Fecha de lanzamiento",
  "fan.psm.spotifyUri": "Enlace de álbum o canción en Spotify",
  "fan.psm.spotifyUriHint": "Opcional antes del lanzamiento: también lo encontramos por UPC/ISRC ese día.",
  "fan.psm.upc": "UPC (opcional)",
  "fan.psm.spotifyArtist": "Enlace de artista en Spotify (los fans te siguen)",
  "fan.psm.appleId": "ID de álbum de Apple Music (opcional)",
  "fan.psm.description": "Mensaje para los fans",
  "fan.psm.descPh": "Cuéntales a tus fans por qué deberían pre-guardar…",
  "fan.psm.background": "Imagen de fondo",
  "fan.psm.uploadBg": "Subir fondo",
  "fan.psm.bgHint": "Recomendado: imagen horizontal de 1920×1080",
  "fan.psm.createBtn": "Crear campaña",
  "fan.psm.creating": "Creando…",
  "fan.psm.created": "Campaña creada",
  "fan.psm.createError": "No se pudo crear la campaña",
  "fan.psm.deleted": "Campaña eliminada",
  "fan.psm.deleteError": "No se pudo eliminar la campaña",
  "fan.psm.fetchError": "No se pudieron cargar las campañas",
  "fan.psm.required": "Elige un lanzamiento y una fecha",
  "fan.psm.empty": "Aún no hay campañas",
  "fan.psm.emptyDesc": "Genera impulso antes del lanzamiento con un pre-guardado real en Spotify.",
  "fan.psm.createFirst": "Crea tu primera campaña",
  "fan.psm.active": "Activa",
  "fan.psm.released": "Publicado",
  "fan.psm.daysLeft": "días restantes",
  "fan.psm.saves": "Pre-guardados en Spotify",
  "fan.psm.emails": "Correos",
  "fan.psm.howItWorks": "Los fans conectan Spotify una vez; el día del lanzamiento la música se guarda sola en su biblioteca.",
  "fan.psm.deleteTitle": "¿Eliminar esta campaña?",
  "fan.psm.deleteDesc": "La página dejará de funcionar. Los pre-guardados existentes no se procesarán.",
  "fan.psm.exportEmails": "Exportar correos",
  "fan.psm.noEmails": "Aún no hay correos",
  "fan.psm.cancel": "Cancelar",
  "fan.psm.editTitle": "Editar campaña",
  "fan.psm.updated": "Campaña actualizada",

  "fan.bl.urlTitle": "Tu URL pública",
  "fan.bl.urlDesc": "Reserva un enlace corto y fácil de recordar para tu página bio.",
  "fan.bl.slugPh": "tunombre",
  "fan.bl.checking": "Comprobando…",
  "fan.bl.available": "Disponible",
  "fan.bl.taken": "Ya está en uso",
  "fan.bl.invalid": "3–30 caracteres: a–z, 0–9, punto, guion, guion bajo",
  "fan.bl.reserved": "Este nombre está reservado",
  "fan.bl.yours": "Esta es tu URL actual",
  "fan.bl.claim": "Reservar",
  "fan.bl.claimed": "¡Tu URL ya está activa!",
  "fan.bl.claimError": "No se pudo reservar esta URL",
  "fan.bl.noSlug": "Reserva una URL para tener un enlace fácil de compartir.",
  "fan.bl.openPage": "Abrir página",
  "fan.bl.namePh": "Tu nombre artístico",
  "fan.bl.bioPh": "Cuéntales a tus fans quién eres…",
  "fan.bl.uploadPhoto": "Subir foto",
  "fan.bl.emptyLinks": "Aún no hay enlaces",
  "fan.bl.emptyLinksDesc": "Añade tu tienda de merch, fechas de gira, newsletter o lo que quieras.",
  "fan.bl.emptyPreview": "Tus enlaces aparecerán aquí",

  "fan.qrg.brand": "Marca",
  "fan.qrg.classic": "Clásico",
  "fan.qrg.inverted": "Invertido",
  "fan.qrg.gold": "Oro",
  "fan.qrg.presets": "Colores predefinidos",
  "fan.qrg.small": "Pequeño (256 px)",
  "fan.qrg.medium": "Mediano (512 px)",
  "fan.qrg.large": "Grande (1024 px)",
  "fan.qrg.lowContrast": "Contraste bajo: algunos teléfonos podrían no leer este código.",
  "fan.qrg.deleteTitle": "¿Eliminar este código QR?",
  "fan.qrg.deleteDesc": "Las copias impresas dejarán de registrarse.",
  "fan.qrg.tracked": "Los escaneos se registran automáticamente",
  "fan.qrg.copyUrl": "Copiar URL de destino",
};

export default { en, tr, es };
